import React, { useState, useEffect } from 'react';
import Appearance from 'styles/Appearance';
import Utils from 'files/Utils.js';
import { VelocityComponent } from 'velocity-react';

const Alert = ({ id, buttons, content, icon, index, message, onCancel, onClick, onClose, title, utils }) => {

    const [visible, setVisible] = useState(false);
    const [scale, setScale] = useState(0);
    const [opacity, setOpacity] = useState(0);
    const [alertButtons, setAlertButtons] = useState([]);
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    })

    const onButtonClick = key => {
        onHideAlert(() => {
            if(key === 'cancel') {
                if(typeof(onCancel) === 'function') {
                    onCancel();
                    return;
                }
            }
            if(typeof(onClick) === 'function') {
                onClick(key);
            }
        });
    }

    const onGeneralKeyDown = evt => {
        if(evt.keyCode === 27) {
            onHideAlert();
        }
    }

    const onHideAlert = callback => {
        setScale(0);
        setOpacity(0);
        setTimeout(() => {
            setVisible(false);
            if(typeof(onClose) === 'function') {
                onClose(id);
            }
            if(typeof(callback) === 'function') {
                callback();
            }
        }, 250);
    }

    const onWindowSizeChange = (e) => {
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        })
    }

    const getWidth = () => {
        if(Utils.isMobile() == true) {
            return size.width - 36;
        }
        if(content) {
            return size.width > 400 ? 400 : (size.width - 30);
        }
        return size.width > 325 ? 325 : (size.width - 30);
    }

    useEffect(() => {
        setVisible(true);
        setTimeout(() => {
            setScale(index > 3 ? 0 : 1 - (index / 4));
            setOpacity(index === 0 ? 1 : 0);
        }, 250)
    }, [index])

    useEffect(() => {

        // add at least one buttons if no buttons are provided
        let next_buttons = buttons || [{
            key: 'cancel',
            title: 'Okay',
            style: 'cancel'
        }];
        setAlertButtons(next_buttons.filter(button => {
            return button.visible !== false;
        }));

        // add resize listener
        // add keydown listener for escape key to close alert if there is a dismiss/cancel button
        window.addEventListener('resize', onWindowSizeChange);
        if(next_buttons.find(button => button.key === 'cancel')) {
            document.addEventListener('keydown', onGeneralKeyDown);
        }

        return () => {
            window.removeEventListener('resize', onWindowSizeChange);
            document.removeEventListener('keydown', onGeneralKeyDown);
        }
    }, []);

    return visible && (
        <div style={{
            alignItems: 'center',
            backgroundColor: Appearance.colors.transparent,
            display: 'flex',
            justifyContent: 'center',
            height: '100%',
            left: 0,
            position: 'fixed',
            top: 0,
            width: '100%',
            zIndex: 9950
        }}>
            <VelocityComponent
            animation={{
                opacity: opacity,
                scale: scale
            }}
            duration={500}
            easing={[250, 20]}>
                <div style={{
                    alignItems: 'center',
                    backgroundColor: Appearance.colors.alert(),
                    borderRadius: 10,
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: size.height - 30,
                    overflow: 'hidden',
                    textAlign: 'center',
                    width: getWidth(),
                    zIndex: 9999
                }}>
                    {icon && typeof(icon) === 'object' && (
                        <div style={{
                            backgroundColor: icon.background_color || Appearance.colors.primary(),
                            border: '3px solid white',
                            borderRadius: 25,
                            boxShadow: window.theme === 'dark' ? '3px 3px 15px rgba(0,0,0,0.25), -3px -3px 15px rgba(255,255,255,0.25)' : '3px 3px 15px #c9c8ca, -3px -3px 15px #ffffff',
                            height: 50,
                            marginTop: 15,
                            overflow: 'hidden',
                            width: 50,
                            ...icon.style
                        }}>
                            <img
                            src={icon.path}
                            style={{
                                height: '100%',
                                resizeMode: 'cover',
                                width: '100%'
                            }}/>
                        </div>
                    )}
                    <span style={{
                        color: Appearance.colors.text(),
                        display: 'block',
                        fontFamily: 'Zen Dots',
                        fontSize: 18,
                        fontWeight: '800',
                        lineHeight: 1.5,
                        marginBottom: 8,
                        paddingLeft: 15,
                        paddingRight: 15,
                        paddingTop: icon ? 8 : 15,
                    }}>{title.toUpperCase()}</span>

                    <div style={{
                        marginBottom: 24,
                        maxHeight: 500,
                        maxWidth: '100%',
                        overflowY: 'scroll',
                        overflowX: 'hidden'
                    }}>
                        <span style={{
                            color: Appearance.colors.subText(),
                            display: 'block',
                            maxWidth: '100%',
                            fontSize: 13,
                            fontWeight: '500',
                            paddingLeft: 15,
                            paddingRight: 15,
                            wordWrap: 'break-word'
                        }}>{message}</span>
                    </div>

                    {content}
                    {alertButtons.map(item => {
                        return (
                            <div
                            key={item.key}
                            className={`alert-item ${window.theme}`}
                            onClick={onButtonClick.bind(this, item.key)}
                            style={{
                                height: 50,
                                width: '100%'
                            }}>
                                <div style={{
                                    height: 50
                                }}>
                                    <div style={{
                                        backgroundColor: Appearance.colors.divider(),
                                        height: 1,
                                        width: '100%'
                                    }}/>
                                    <div style={{
                                        alignItems: 'center',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        height: 50
                                    }}>
                                        <span style={{
                                            color: (item.style == 'cancel' || item.style == 'destructive') ? Appearance.colors.text() : Appearance.colors.primary(),
                                            fontSize: 13,
                                            fontWeight: '400',
                                            textAlign:'center'
                                        }}>{item.title}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </VelocityComponent>
        </div>
    )
}

export default Alert;
